"use strict";

exports.__esModule = true;
exports.default = void 0;
var _root = _interopRequireDefault(require("./_root.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** Built-in value references. */
var _Symbol = _root.default.Symbol;
var _default = exports.default = _Symbol;